"use strict";

/* Directives */
_BannerFlowApp.directive("headerBrandPicker", function ($timeout, Utils, AuthInfo) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "/legacy-app/js/directives/header/headerBrandPicker.html",
        controller: function ($scope, $attrs) {
            $scope.loading = false;

            $scope.gotoSettings = function (brand, $event) {
                $scope.loading = true;
                $event.preventDefault();
                $event.stopPropagation();

                if (Utils.CheckIfRootScopeIsDirty()) {
                    if (Utils.ConfirmAndNavigate()) {
                        changeSettings();
                    } else {
                        $scope.loading = false;
                    }
                } else {
                    changeSettings();
                }

                function changeSettings() {
                    $timeout(function () {
                        Utils.GotoV2BrandSettings("overview", brand.slug);
                    }, 100);
                }
            };

            $scope.changeBrand = function (brand, $event) {
                if (Utils.CheckIfRootScopeIsDirty()) {
                    if (Utils.ConfirmAndNavigate()) {
                        change();
                    }
                } else {
                    change();
                }

                function change() {
                    $scope.loading = true;
                    $event.preventDefault();
                    $event.stopPropagation();

                    $timeout(function () {
                        AuthInfo.ChangeBrand(brand);
                    }, 100);
                }
            };
        }
    };
});
